import { alpha, Box, Paper, useTheme } from "@mui/material";
import type { BoxProps, PaperProps } from "@mui/material";

type OutlinedCardProps = Omit<BoxProps & PaperProps, "variant">;

const OutlinedCard: React.FC<OutlinedCardProps> = ({ children, sx, ...props }) => {
  const theme = useTheme();

  return (
    <Box
      component={Paper}
      variant="outlined"
      sx={{
        p: 1,
        borderColor: alpha(theme.palette.text.primary, 0.25),
        [theme.breakpoints.down("sm")]: {
          borderRadius: 0,
          borderLeft: 0,
          borderRight: 0,
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default OutlinedCard;
